import { render, staticRenderFns } from "./groups.vue?vue&type=template&id=7ea78764"
import script from "./groups.vue?vue&type=script&lang=js"
export * from "./groups.vue?vue&type=script&lang=js"
import style0 from "./groups.vue?vue&type=style&index=0&id=7ea78764&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports